import { getTourV2IdForCheckoutItem, isTourV2Item } from 'lib/checkout'

export const cartIncludesTourV2 = (state: App.State) => state.checkout.cart.items.some(isTourV2Item)

export const isCartItemLeTour = (state: App.State) => {
  const cartItems = state.checkout.cart.items
  const tourV2Offers = state.offer.tourV2Offers
  const item = cartItems.find(isTourV2Item)
  if (!item) {
    return false
  }
  const offer = tourV2Offers[getTourV2IdForCheckoutItem(item)]
  return offer?.isLeTour
}
